import { useCallback, useEffect, useState } from 'react'

// Vote options come from the "fixture-voting" dropdown ("3 Votes", "2 Votes", "1 Vote"), each
// with an id that a cast vote points at through `voting_id`.
export const voteKey = (option) => `vote_${option.id}`

// Adds one count column per vote option to every player row, from the player's cast votes.
export const withVoteCounts = (players = [], options = []) =>
  players.map((player) => {
    const cast = player?.get_fixture_voting || []
    const row = { ...player }
    options.forEach((option) => {
      row[voteKey(option)] = cast.filter((vote) => vote.voting_id === option.id).length
    })
    return row
  })

// Loads one voting endpoint and keeps its loading / error state. `request` must be stable.
export const useVotingRequest = (request) => {
  const [response, setResponse] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)

  const load = useCallback(() => {
    setLoading(true)
    setError(false)
    request()
      .then((res) => {
        if (res.status === 200) setResponse(res)
        else setError(true)
      })
      .catch(() => setError(true))
      .finally(() => setLoading(false))
  }, [request])

  useEffect(() => {
    load()
  }, [load])

  return { response, loading, error, reload: load }
}
